import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable()
export class RequestService {

  private cancelRequestSubject = new BehaviorSubject<boolean>(null);

  public cancelRequest(): void {
    this.cancelRequestSubject.next(true);
  }

  public getCancelRequestObservable(): Observable<boolean> {
    return this.cancelRequestSubject.asObservable();
  }

}
